import { render, staticRenderFns } from "./CategoryMenuGroupOrders.vue?vue&type=template&id=72619000&scoped=true"
import script from "./CategoryMenuGroupOrders.vue?vue&type=script&lang=js"
export * from "./CategoryMenuGroupOrders.vue?vue&type=script&lang=js"
import style0 from "./CategoryMenuGroupOrders.vue?vue&type=style&index=0&id=72619000&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72619000",
  null
  
)

export default component.exports